import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-trafford',
    templateUrl: './page-trafford.component.html',
    styleUrls: ['./page-trafford.component.css'],
    standalone: false
})
export class PageTraffordComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  schools = [
    { name: 'Sale Grammar School', url: 'https://www.salegrammar.co.uk/' },
    { name: 'Stretford Grammar School', url: 'http://www.stretfordgrammar.com/'},
    { name: 'Urmston Grammar School', url: 'http://www.urmstongrammar.org.uk/'},
    { name: 'Altrincham Grammar School for Girls', url: 'https://aggs.bright-futures.co.uk/'},
    { name: 'Altrincham Grammar School for Boys', url: 'https://www.agsb.co.uk/'},
  ]

}
